// "Senast använda" in the composer's emoji picker (AMR-414): the last eight, per browser
export interface IRecentEmoji {
    unicode: string;
    shortname: string;
    imageUrl: string;
}

const storageKey = "spintr.composer.recentEmojis";
const maxRecentEmojis = 8;

export const readRecentEmojis = (): IRecentEmoji[] => {
    try {
        const stored = JSON.parse(localStorage.getItem(storageKey) || "[]");

        return Array.isArray(stored)
            ? stored.filter((emoji) => emoji && typeof emoji.unicode === "string" && typeof emoji.imageUrl === "string").slice(0, maxRecentEmojis)
            : [];
    } catch {
        return [];
    }
};

export const addRecentEmoji = (recent: IRecentEmoji[], emoji: IRecentEmoji): IRecentEmoji[] =>
    [emoji, ...recent.filter((e) => e.unicode !== emoji.unicode)].slice(0, maxRecentEmojis);

export const saveRecentEmojis = (recent: IRecentEmoji[]): void => {
    try {
        localStorage.setItem(storageKey, JSON.stringify(recent));
    } catch {
        /* private mode or full storage: the recents just aren't kept */
    }
};

/**
 * The emoji of a JoyPixels picker image, from its file name: ".../png/unicode/32/1f44d-1f3fb.png"
 * is U+1F44D U+1F3FB. Undefined when the image isn't one.
 */
export const getRecentEmojiFromImage = (image: HTMLImageElement | null | undefined): IRecentEmoji | undefined => {
    const match = image ? /\/([0-9a-f]+(?:-[0-9a-f]+)*)\.png(?:\?.*)?$/i.exec(image.src || "") : null;

    if (!image || !match) {
        return undefined;
    }

    return {
        unicode: String.fromCodePoint(...match[1].split("-").map((hex) => parseInt(hex, 16))),
        shortname: image.title || "",
        imageUrl: image.src,
    };
};
